import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import BasketOptionalPartsTemplate from './BasketOptionalPartsTemplate';
import { rem } from 'polished';

export const BasketOptionalPartsStyled = styled(BasketOptionalPartsTemplate)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .Collapsible__contentInner {
        padding-bottom: ${rem(32)};
    }

    .Collapsible__trigger button {
        width: 100%;
    }

    .titleWrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .parts {
        justify-content: space-between;

        @media (min-width: ${breakpoints.md}px) {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: flex-start;

            .feesPart {
                &:nth-child(odd) {
                    margin-right: ${rem('16px')};
                }

                &:last-child {
                    margin-bottom: unset;
                }
            }

            .accPart {
                &:nth-child(even) {
                    margin-right: ${rem('16px')};
                }

                &:nth-last-child(2),
                &:last-child {
                    margin-bottom: unset;
                }
            }
        }

        &__description {
            padding: 0 0 ${rem(32)} 0;
            width: 100%;
            margin: unset;
        }

        &__title {
            width: 100%;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            padding-bottom: ${rem(8)};
        }

        .part {
            border: 1px solid ${({ theme }) => theme.colors.grey25};
            cursor: pointer;
            margin: ${rem(8)} 0;
            background: none;
            width: 100%;
            text-align: left;
            padding: ${rem(24)};

            &:hover,
            &:focus-visible,
            &.selected {
                background: ${({ theme }) => theme.colors.primaryLight};
                border: 2px solid ${({ theme }) => theme.colors.primary};
                padding: ${rem(23)};
            }

            @media (min-width: ${breakpoints.md}px) {
                width: 49%;
            }

            img {
                width: 100%;
            }

            &__name {
                padding-left: ${rem(40)};
                position: relative;
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
                color: ${({ theme }) => theme.colors.black2};
                line-height: 1.43;

                .checkbox {
                    position: absolute;
                    left: ${rem(0)};
                    top: ${rem(0)};
                }
            }

            &__priceWrapper {
                padding-top: ${rem(5)};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }

            &__descriptionWrapper {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};

                &_full {
                    -webkit-line-clamp: unset !important;
                }

                &_min {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                &_link {
                    background: none;
                    padding: 0;
                    border: none;
                    cursor: pointer;
                    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                    font-size: ${({ theme }) => theme.fontSizes.textBase};
                    text-decoration: underline;
                    margin-top: ${rem(10)};
                }
            }
        }
    }

    .spinnerWrapper {
        width: 100%;
        padding-top: ${rem(20)};
        flex-direction: row;
    }
`;
